import { api } from "jiffy-api";

import { getBusinessLinePath } from "components/checkout_v2/checkout-config";

export const logCheckoutData = async (orderNumber, payload, kind) => {
  const loggerPayload = { order_number: orderNumber, data: payload, kind };

  try {
    await api.jiffyshirts.checkout.log(loggerPayload);
  } catch (e) {
    console.log(e);
  }
};

export const getDeliveryDates = async orderNumber => {
  try {
    const cacheBuster = new Date().getTime();
    const payload = {
      cb: cacheBuster,
      order_type: getBusinessLinePath(),
      order_number: orderNumber
    };
    const delivery = await api.checkoutV2.delivery(payload);
    return delivery;
  } catch (error) {
    window.Honeybadger?.notify("[product-collections] Error fetching delivery dates", {
      params: { error: JSON.stringify(error) }
    });
    return error;
  }
};
